import { Card, Skeleton, Stack } from '@mantine/core'

export const DeviceInfoSkeleton = () => {
  return (
    <Stack gap="md">
      <Skeleton height={36} width={320} />

      <Card withBorder>
        <Stack gap="lg">
          <Skeleton height={28} width={320} />
          <Skeleton height={28} width={400} />
          <Skeleton height={28} width={240} />
          <Skeleton height={28} width={200} />
        </Stack>
      </Card>
    </Stack>
  )
}
